import { FC } from "react";
import { Button, HStack, Stack, Text, useMediaQuery } from "@chakra-ui/react";

import { Info2Icon } from "../../../icons";
import { useAppModal } from "../../Modals";
import { PaymentsScheduleItem } from "./PaymentScheduleItem";
import { IScheduleItem } from "../../../../api/schedule/types.ts";
import { PaymentsScheduleListInfoModal } from "./PaymentScheduleListInfoModal";

interface Props {
  schedule: IScheduleItem[];
}

export const PaymentsScheduleList: FC<Props> = ({ schedule }) => {
  const { showModal } = useAppModal();
  const [isSmallScreen] = useMediaQuery("(max-width: 355px)");

  const onClick = () => {
    showModal({
      content: onClose => <PaymentsScheduleListInfoModal onClose={onClose} />,
    });
  };

  if (schedule.length === 0) {
    return null;
  }

  return (
    <Stack spacing="23px" px="17px" py="20px" borderRadius="16px" bg="white">
      <HStack mt="1px" justifyContent="space-between">
        <Text>График</Text>
        <Button minW="20px" h="20px" p="0" colorScheme="transparent" onClick={onClick}>
          <Info2Icon />
        </Button>
      </HStack>

      <Stack spacing={isSmallScreen ? "10px" : "22px"}>
        {schedule.map(payment => (
          <PaymentsScheduleItem key={payment.idx} payment={payment} />
        ))}
      </Stack>
    </Stack>
  );
};
